import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from "react";
import objectAssign from "object-assign";

var Iframe = function Iframe(_ref) {
  var url = _ref.url,
      allowFullScreen = _ref.allowFullScreen,
      position = _ref.position,
      display = _ref.display,
      height = _ref.height,
      width = _ref.width,
      overflow = _ref.overflow,
      styles = _ref.styles,
      onLoad = _ref.onLoad,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      scrolling = _ref.scrolling,
      id = _ref.id,
      frameBorder = _ref.frameBorder,
      ariaHidden = _ref.ariaHidden,
      sandbox = _ref.sandbox,
      allow = _ref.allow,
      className = _ref.className,
      title = _ref.title,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      name = _ref.name,
      target = _ref.target,
      loading = _ref.loading,
      importance = _ref.importance,
      referrerpolicy = _ref.referrerpolicy,
      allowpaymentrequest = _ref.allowpaymentrequest,
      src = _ref.src,
      key = _ref.key;
  var defaultProps = objectAssign({
    src: src || url,
    target: target || null,
    style: {
      position: position || null,
      display: display || "initial",
      overflow: overflow || null
    },
    scrolling: scrolling || null,
    allowpaymentrequest: allowpaymentrequest || null,
    importance: importance || null,
    sandbox: sandbox && _toConsumableArray(sandbox).join(" ") || null,
    loading: loading || null,
    styles: styles || null,
    name: name || null,
    className: className || null,
    allowFullScreen: "allowFullScreen" || null,
    referrerpolicy: referrerpolicy || null,
    title: title || null,
    allow: allow || null,
    id: id || null,
    "aria-labelledby": ariaLabelledby || null,
    "aria-hidden": ariaHidden || null,
    "aria-label": ariaLabel || null,
    width: width || null,
    height: height || null,
    onLoad: onLoad || null,
    onMouseOver: onMouseOver || null,
    onMouseOut: onMouseOut || null,
    key: key || "iframe"
  });
  var props = Object.create(null);

  for (var _i = 0, _Object$keys = Object.keys(defaultProps); _i < _Object$keys.length; _i++) {
    var prop = _Object$keys[_i];

    if (defaultProps[prop] != null) {
      props[prop] = defaultProps[prop];
    }
  }

  for (var _i2 = 0, _Object$keys2 = Object.keys(props.style); _i2 < _Object$keys2.length; _i2++) {
    var i = _Object$keys2[_i2];

    if (props.style[i] == null) {
      delete props.style[i];
    }
  }

  if (props.styles) {
    for (var _i3 = 0, _Object$keys3 = Object.keys(props.styles); _i3 < _Object$keys3.length; _i3++) {
      var _key = _Object$keys3[_i3];

      if (props.styles.hasOwnProperty(_key)) {
        props.style[_key] = props.styles[_key];
      }

      if (Object.keys(props.styles).pop() == _key) {
        delete props.styles;
      }
    }
  }

  if (allowFullScreen) {
    if ("allow" in props) {
      var currentAllow = props.allow.replace("fullscreen", "");
      props.allow = "fullscreen ".concat(currentAllow.trim()).trim();
    } else {
      props.allow = "fullscreen";
    }
  }

  if (frameBorder >= 0) {
    if (!props.style.hasOwnProperty("border")) {
      props.style.border = frameBorder;
    }
  }

  return React.createElement("iframe", Object.assign({}, props));
};

export default Iframe;